/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { LadderResponse } from './LadderResponse';
import {
    LadderResponseFromJSON,
    LadderResponseFromJSONTyped,
    LadderResponseToJSON,
    LadderResponseToJSONTyped,
} from './LadderResponse';

/**
 * 
 * @export
 * @interface GetPublicLaddersResponse
 */
export interface GetPublicLaddersResponse {
    /**
     * 
     * @type {Array<LadderResponse>}
     * @memberof GetPublicLaddersResponse
     */
    ladders?: Array<LadderResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetPublicLaddersResponse
     */
    paginationInfo?: PaginationInfo;
}

/**
 * Check if a given object implements the GetPublicLaddersResponse interface.
 */
export function instanceOfGetPublicLaddersResponse(value: object): value is GetPublicLaddersResponse {
    return true;
}

export function GetPublicLaddersResponseFromJSON(json: any): GetPublicLaddersResponse {
    return GetPublicLaddersResponseFromJSONTyped(json, false);
}

export function GetPublicLaddersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPublicLaddersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ladders': json['ladders'] == null ? undefined : ((json['ladders'] as Array<any>).map(LadderResponseFromJSON)),
        'paginationInfo': json['paginationInfo'] == null ? undefined : PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function GetPublicLaddersResponseToJSON(json: any): GetPublicLaddersResponse {
    return GetPublicLaddersResponseToJSONTyped(json, false);
}

export function GetPublicLaddersResponseToJSONTyped(value?: GetPublicLaddersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ladders': value['ladders'] == null ? undefined : ((value['ladders'] as Array<any>).map(LadderResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

